import { render, staticRenderFns } from "./xlsx.vue?vue&type=template&id=5fc6185f&"
import script from "./xlsx.vue?vue&type=script&lang=js&"
export * from "./xlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "xlsx.vue"
export default component.exports